<script setup lang="ts">
import { isPlatform } from '@ionic/vue'
import { onMounted } from 'vue'
import logo from '@/assets/logo.png'

const appStoreLink = 'https://apps.apple.com/us/app/sekai/id6466694908'
const googlePlayLink
  = 'https://play.google.com/store/apps/details?id=ai.versa.sekai'

onMounted(() => {
  console.debug(window.navigator.userAgent)
  // bring up the app store or google play store
  if (isPlatform('mobileweb')) {
    // open new tab
    if (isPlatform('ios')) {
      window.open(appStoreLink, '_blank')
    }
    else {
      window.open(googlePlayLink, '_blank')
    }
  }
})
</script>

<template>
  <div class="flex flex-center items-center bg p-4 gap-4">
    <img class="w-12 h-12 rd-4" :src="logo" alt="Sekai">
    <div class="flex flex-col gap-2">
      <p class="text-3 leading-1.2 fw-700">
        Sekai
      </p>
      <p class="text-2.5 fw-500 text-nowrap">
        Live in your Fanfiction
      </p>
    </div>
    <a
      class="btn-primary text-2.5 py-1 h-auto"
      :href="`${isPlatform('ios') ? appStoreLink : googlePlayLink}`"
      target="_blank"
    >
      Open {{ isPlatform("ios") ? "App Store" : "Google Play" }}
    </a>
  </div>
</template>

<style scoped>
.bg {
  background-color: rgba(255, 255, 255, 0.6);
}
</style>
